<script>
import { mapGetters } from 'vuex'
import Storage from '@/utils/storage'
import messageHandler from '@/mixins/message'
import pathToRegexp from 'path-to-regexp'

export default {
  name: 'BaseController',
  mixins: [ messageHandler ],
  created: function () {
    // if (!this.isLoggedIn) {
    //   this.logout()
    // }
  },
  methods: {
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    formValidate: function (formName, cb) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formValid = true
          if (cb) cb()
        }
        else {
          for (let i = 0; i < self.$refs[formName].fields.length; i++) {
            let item = self.$refs[formName].fields[i]
            if (item.validateState === 'error') {
              if (item.$children[0] && typeof item.$children[0].focus === 'function') {
                item.$children[0].focus()
              }
              return
            }
          }
          this.formValid = false
        }
      })
    },
    pathCompile(path) {
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    navigate: function (params) {
      if (this.pageControllerName) {
        let data = {}
        this.copyData(this, data, this.getDataToCopy())
        Storage.setItem(this.getSessionKey('Edit'), data)
      }
      params.params.__isValid = 1
      if (params.name === this.$route.name) {
        // eslint-disable-next-line handle-callback-err
        this.$router.push({ path: this.$route.path + '?next=' + new Date().toJSON() }).then(() => {
          return this.$router.push(params)
        }).catch(() => {})
      }
      else {
        // eslint-disable-next-line handle-callback-err
        this.$router.push(params).catch(() => {})
      }
    },
    formFields: function () {
      let arr = []
      for (let k in this.form) {
        arr.push(k)
      }
      return arr
    },
    viewEdit: function (routePage, isCreate, isReadOnly, isCopy, list) {
      routePage.params.isReadOnly = isReadOnly
      routePage.params.isCopy = isCopy
      routePage.params.create = isCreate
      routePage.params.list = list
      this.navigate(routePage)
    },
    edit: function (api, routePage, condlist, isReadOnly, isCopy) {
      this.$tango[api](condlist).then(rep => {
        if (rep.resultCode === 0) {
          rep['isReadOnly'] = Boolean(isReadOnly)
          rep['isCopy'] = Boolean(isCopy)
          for (let i in condlist) {
            if (!rep[i]) rep[i] = condlist[i]
          }
          this.navigate(routePage, rep)
        }
        else {
          throw new Error(this.$t(this.resultMessage[rep.resultCode]))
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err.message
        })
      })
    },
    search: function () {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      }
      else {
        this.getPage()
      }
    },
    formDefaults: function () {
    },
    getDefaultOrder: function () {
      return ''
    },
    reset: function () {
      let list = this.formFields()
      for (let i = 0; i < list.length; i++) {
        this.form[list[i]] = null
      }
      this.formDefaults()
      this.displayResults = false
      this.showResults = []
      this.dataList = []
      this.totalCount = 0
    },
    getLabel: function (hash, id, key) {
      let elem = hash[id]
      return elem ? elem[key] || '' : ''
    },
    fillCondition: function (arr, arity, fieldName, originForm) {
      if (typeof originForm === 'undefined') originForm = this.form
      if (originForm[fieldName]) {
        if (Array.isArray(originForm[fieldName])) {
          if (originForm[fieldName].length) {
            let cond = { 'field name': fieldName }
            if ((originForm[fieldName].length === 1) && (arity !== 0)) {
              cond.operator = '='
              cond.value = [originForm[fieldName][0]]
              arr.push(cond)
            }
            else {
              cond.operator = 'in'
              cond.value = [].concat(originForm[fieldName])
              arr.push(cond)
            }
          }
        }
        else if (originForm[fieldName] !== -1) {
          let cond = { 'field name': fieldName }
          cond.operator = '='
          cond.value = [originForm[fieldName]]
          arr.push(cond)
        }
      }
    },
    getRealColumn: function (col) {
      return col
    },
    sortTable: function (infos) {
      this.orderBy = infos.prop ? infos.prop + (infos.order === 'ascending' ? ' ASC' : ' DESC') : this.orderBy
      this.getPage(this.currentPage)
    },
    makeHash: function (list, id) {
      let hash = {}
      if (list) {
        for (let item of list) {
          hash[item[id]] = item
        }
      }
      return hash
    },
    getSessionKey: function (name) {
      return this.pageControllerName() + name + 'Data'
    },
    getDataToCopy: function () {
      return this.formFields().map(val => 'form.' + val)
    },
    getListDataToCopy: function () {
      return this.formFields().map(val => 'form.' + val)
    },
    restoreFieldValue: function (key, val) {
      return val
    },
    copyDataRec: function (src, dst, list) {
      let key = list.splice(0, 1)[0]
      if (list.length) {
        if (dst[key] === undefined) {
          dst[key] = {}
        }
        this.copyDataRec(src[key], dst[key], list)
      }
      else {
        dst[key] = this.restoreFieldValue(key, src[key])
      }
    },
    copyData: function (src, dst, list) {
      for (let i = 0; i < list.length; i++) {
        this.copyDataRec(src, dst, list[i].split('.'))
      }
    },
    searchData: function (api, page, condlist, groupby, converters, processRow, finalize, responseField, originForm) {
      let conditions = {
        conditions: [ ],
        offset: page,
        indDetail: 0,
        limit: this.pageSize
      }
      this.dataList = []

      if (this.orderBy !== '') {
        conditions.order = this.orderBy
      }
      if (groupby) {
        conditions.groupby = groupby
      }
      let arr = null
      if (Array.isArray(condlist)) {
        arr = condlist
      }
      else {
        arr = Object.keys(condlist)
      }
      for (let i = 0; i < arr.length; i++) {
        if (typeof arr[i] === 'function') {
          arr[i](originForm, conditions.conditions)
        }
        else {
          if (typeof arr[i] === 'string' || arr[i] instanceof String) {
            this.fillCondition(conditions.conditions, 1, arr[i], originForm)
            if (api.match(/read/i)) {
              if (typeof originForm === 'undefined') originForm = this.form
              conditions[arr[i]] = originForm[arr[i]]
            }
          }
          else {
            conditions.conditions.push(arr[i])
          }
        }
      }
      this.$tango[api](conditions).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error(this.$t('fetch Contract List Failed!') + ' ' + this.$t(this.resultMessage[rep.resultCode]))
        }
        let resp = rep[responseField] || []
        let arr = []
        for (let i = 0; i < resp.length; i++) {
          let row = {}
          for (let fieldName in resp[i]) {
            if (converters[fieldName]) {
              row[fieldName] = converters[fieldName](resp[i][fieldName])
            }
            else {
              row[fieldName] = resp[i][fieldName]
            }
          }
          if (processRow) {
            if (processRow(row, arr)) {
              arr.push(row)
            }
          }
          else {
            arr.push(row)
          }
        }
        this.dataList = arr
        let offset = rep.offset ? Number(rep.offset) : 0
        if (offset <= 0) offset = 1
        this.currentPage = offset
        this.totalCount = rep.totalCount
        if (finalize) finalize()
        if (this.$refs.spinner) this.$refs.spinner.hide()
      }).catch(err => {
        if (this.$refs.spinner) this.$refs.spinner.hide()
        this.$message({
          type: 'error',
          message: err.message
        })
      })

      this.isLoading = true
    },
    removeElem: function () {
    },
    returnPage () {
      if (this.$route.meta.parent) {
        // eslint-disable-next-line handle-callback-err
        this.$router.push({ name: this.$route.meta.parent }).catch(() => {})
      }
      else {
        this.$router.push({ path: '/home' })
      }
    },
    getStateLabel (codeCountry, stateCode) {
      if (!stateCode || !codeCountry) return ''
      let state = (this.countryById[codeCountry].stateList || []).filter(s => s.stateCode === stateCode)
      return state ? state.label : ''
    },
    resetPermission () {
      return this.$tango.searchPermission().then(rep => {
        if (rep.resultCode !== 0) throw new Error('Search permission')
        this.$store.dispatch('user/setPermission', rep.permissionList)
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
        })
    }
  },
  computed: {
    ...mapGetters([ 'isAdmin', 'isLoggedIn', 'userStatusList', 'pageSize', 'countryList' ]),
    ...mapGetters('resultMessage', [ 'resultMessage' ]),
    userStatusListById: function () { return this.makeHash(this.userStatusList, 'id') },
    countryById: function () { return this.makeHash(this.countryList, 'countryCode') }
  },
  data () {
    return {
      showSearch: ['1'],
      showResults: [ ],
      isLoading: false,
      displayResults: false,
      currentPage: 1,
      totalCount: 0,
      dataList: [],
      orderBy: this.getDefaultOrder()
    }
  }
}
</script>
